module.exports = __webpack_public_path__ + "static/media/AIDERES.dc208a5b.png";